module.exports = __webpack_public_path__ + "media/assets/images/header_mobile-f5ec3ca592403cfae749ec83114c467e.svg";